import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../services/i18nService';
import styles from './keyboardHelpAndPrompt.scss';
import Prompt from '../interactions/Prompt';
import questionReader from '../../../store/readHelpers/QuestionReader';
import extendedTextA11ySelector from '../../../selectors/question/interactions/extendedTextInteraction/ExtendedTextA11ySelector';

class KeyboardHelpAndPrompt extends React.PureComponent {
    static propTypes = {
        captionKey: PropTypes.string.isRequired,
        model: PropTypes.object.isRequired,
        showAccessibilityHelpers: PropTypes.bool,
        questionModel: PropTypes.object,
        tabIndex: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    toggleOpenState = () => {
        this.setState({ open: !this.state.open });
    };

    render() {
        const { captionKey, model, showAccessibilityHelpers, questionModel, tabIndex } = this.props;
        const textStyle = `${styles.keyboardHelpText} ${this.state.open ? '' : 'hidden'}`;
        const buttonStyle = `${styles.button} ${this.state.open ? styles.active : ''}`;
        const showKeyboardHelp = questionReader.isGapMatchQuestionWithMultipleInteractions(questionModel) ? model.showKeyboardHelp : true;

        // Get accessibility attributes for help button
        const helpButtonA11yAttrs = extendedTextA11ySelector.getHelpButtonA11yAttributes();

        return (
            <div className={`${styles.keyboardHelpWrapper} kb-help-and-prompt-wrapper`}>
                <div className={styles.promptAndButtonRow}>
                    <Prompt model={model.prompt} extraClassNames={styles.prompt} />
                    { showAccessibilityHelpers && showKeyboardHelp ?
                        <button
                            aria-label={helpButtonA11yAttrs.ariaLabel}
                            aria-expanded={this.state.open}
                            className={`${buttonStyle} keyboard-help-button`}
                            type="button"
                            onClick={this.toggleOpenState}
                            data-type="accessibility-helper"
                            tabIndex={0}
                        >
                            <i className="fa fa-keyboard-o" aria-hidden="true" />
                            { t('interactions.keyboardHelp') }
                        </button>
                        : null
                    }
                </div>
                <div
                    role="alert"
                    className={textStyle}
                    dangerouslySetInnerHTML={{ __html: t(captionKey) }}
                    tabIndex={tabIndex}
                />
            </div>
        );
    }
}

export default KeyboardHelpAndPrompt;
